import React, { useState, useContext } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import Navbar from '../components/Navbar';
import languageContext from "../context/language/languageContext";

const SignupForm = () => {
  const navigate = useNavigate();
  // Form states
  const [name, setName] = useState("");
  const [center, setCenter] = useState("");
  const [state, setState] = useState("");
  const [city, setCity]=useState("")
  const [doctor, setDoctor] = useState("");
  const [department, setDepartment]=useState("")
  const { lang, phone, setPhone } = useContext(languageContext);
  // const [alldepartments, setalldepartments] = useState([
  //   { name: "Cardiology" },
  //   { name: "Neurology" },
  //   { name: "Orthopedics" },
  //   { name: "Pediatrics" },
  //   { name: "Gynecology" },
  //   { name: "Oncology" },
  //   { name: "ENT" },
  //   { name: "General Medicine" }
  // ]);
  
  const [loader, setLoader] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  // Handle form submission
  const handleSignup = async (e) => {
    e.preventDefault();
  
    // Validate phone number
    if (!phone || phone.length !== 10 || isNaN(phone)) {
      setResponseMessage("Please enter a valid 10-digit phone number.");
      return;
    }
  
    // Prepare header and request body
    const headerList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };
  
    const bodyContent = JSON.stringify({
      phone,
      name,
      center_hospital: center,
      city,
      state,
      under_dr_name: doctor,
      department,
    });
  
    try {
      setLoader(true);
      console.log("Sending OTP request...");
  
      // Make API request
      const response = await axios.post(
        "https://www.careplus.gopillz.com/nurse_sigup_send_otp",
        bodyContent,
        { headers: headerList }
      );
  
      console.log("OTP request successful:", response.data);
  
      // Check response status and handle accordingly
      if (response.status === 202) {
        setResponseMessage(response.data.message || "OTP sent successfully.");
        // Navigate only after a successful response
        navigate("/otp", { state: { from: "signup" } });
      } else if (response.status === 400) {
        setResponseMessage(response.data.msg || "Error during signup.");
      } else {
        setResponseMessage("Unexpected response from the server.");
      }
    } catch (error) {
      // Handle errors properly
      console.error("Error sending OTP:", error.response?.data || error.message);
      setResponseMessage(
        error.response?.data?.msg || "Failed to send OTP. Please try again."
      );
    } finally {
      setLoader(false);
    }
  };
  

  // <option value="Cardiology">Cardiology</option>
  //   <option value="Neurology">Neurology</option>
  //   <option value="Orthopedics">Orthopedics</option>
  //   <option value="Pediatrics">Pediatrics</option>
  //   <option value="Gynecology">Gynecology</option>
  //   <option value="Oncology">Oncology</option>
  //   <option value="ENT">ENT</option>
  //   <option value="General Medicine">General Medicine</option>

  return (
    <div>
      <Navbar />

      {/* Main container */}
      <div className="w-[100vw] flex flex-col items-center justify-center text-center font-bold bg-bgall h-[calc(100vh-100px)]">

        {/* Circles for progress indicator */}
        <div className="flex mt-6 space-x-2">
          <div className="bg-bgcircle w-[10px] h-[10px] rounded-full"></div>
          <div className="bg-gray-300 w-[10px] h-[10px] rounded-full"></div>
          <div className="bg-gray-300 w-[10px] h-[10px] rounded-full"></div>
        </div>

        {/* Form Heading */}
        <div className="mt-6 mb-3 text-xl font-semibold text-gray-700">
          Enter Your Details
        </div>

        {/* Compact Form Wrapper */}
        <div className="bg-white shadow-lg rounded-xl px-6 py-4 sm:w-[90%] md:w-[50%] lg:w-[30%]">

          {/* Form Start */}
          <form onSubmit={handleSignup} className="space-y-3">
            
            {/* Name Input */}
            <div className="text-left">
              <label className="text-[15px] text-gray-700">Enter your Name</label>
              <input
                type="text"
                required
                className="w-full px-3 py-1.5 border rounded-lg bg-bginput my-1 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all text-sm"
                placeholder="Enter Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            {/* Center/Hospital Input */}
            <div className="text-left">
              <label className="text-[15px] text-gray-700">Enter your Center/Hospital</label>
              <input
                type="text"
                required
                className="w-full px-3 py-1.5 border rounded-lg bg-bginput my-1 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all text-sm"
                placeholder="Enter Center/Hospital"
                value={center}
                onChange={(e) => setCenter(e.target.value)}
              />
            </div>

            <div className="text-left">
  <label className="text-[15px] text-gray-700">Choose your Department</label>
  <select
  required
  className="w-full px-3 py-1.5 border rounded-lg bg-bginput my-1 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all text-sm"
  value={department}
  onChange={(e) => setDepartment(e.target.value)}
>
  <option value="" disabled hidden>
    Select Department
  </option>
  
  {/* Medical Specialties */}
  <optgroup label="Medical Specialties">
    <option value="Allergy Nursing">Allergy Nursing</option>
    <option value="Cardiology">Cardiology</option>
    <option value="Dermatology">Dermatology</option>
    <option value="Endocrinology">Endocrinology</option>
    <option value="Gastroenterology">Gastroenterology</option>
    <option value="Hematology">Hematology</option>
    <option value="Infectious Diseases">Infectious Diseases</option>
    <option value="Nephrology">Nephrology</option>
    <option value="Neurology">Neurology</option>
    <option value="Oncology">Oncology</option>
    <option value="Pulmonology">Pulmonology</option>
    <option value="Rheumatology">Rheumatology</option>
    <option value="Adolescent Medicine">Adolescent Medicine</option>
    <option value="Aerospace Nursing">Aerospace Nursing</option>
    <option value="Alternative/Complementary Nursing">Alternative/Complementary Nursing</option>
    <option value="Anesthesiology">Anesthesiology</option>
    <option value="Cardiovascular Nursing">Cardiovascular Nursing</option>
    <option value="Clinical Genetics">Clinical Genetics</option>
    <option value="Clinical Neurophysiology">Clinical Neurophysiology</option>
    <option value="Developmental-Behavioral Pediatrics">Developmental-Behavioral Pediatrics</option>
  </optgroup>

  {/* Surgical Specialties */}
  <optgroup label="Surgical Specialties">
    <option value="Cardiothoracic Surgery">Cardiothoracic Surgery</option>
    <option value="General Surgery">General Surgery</option>
    <option value="Neurosurgery">Neurosurgery</option>
    <option value="Orthopedic Surgery">Orthopedic Surgery</option>
    <option value="Plastic Surgery">Plastic Surgery</option>
    <option value="Urology">Urology</option>
    <option value="Vascular Surgery">Vascular Surgery</option>
    <option value="Abdominal Transplant Surgery">Abdominal Transplant Surgery</option>
    <option value="Bariatric Surgery">Bariatric Surgery</option>
    <option value="Cardiovascular Surgery">Cardiovascular Surgery</option>
    <option value="Colorectal Surgery">Colorectal Surgery</option>
    <option value="Craniofacial Surgery">Craniofacial Surgery</option>
    <option value="Endocrine Surgery">Endocrine Surgery</option>
    <option value="Endovascular Surgery">Endovascular Surgery</option>
    <option value="Gynecologic Surgery">Gynecologic Surgery</option>
  </optgroup>

  {/* Pediatric and Neonatal Specialties */}
  <optgroup label="Pediatric and Neonatal Specialties">
    <option value="Neonatology">Neonatology</option>
    <option value="Pediatric Cardiology">Pediatric Cardiology</option>
    <option value="Pediatric Endocrinology">Pediatric Endocrinology</option>
    <option value="Pediatric Gastroenterology">Pediatric Gastroenterology</option>
    <option value="Pediatric Hematology/Oncology">Pediatric Hematology/Oncology</option>
    <option value="Pediatric Nephrology">Pediatric Nephrology</option>
    <option value="Pediatric Neurology">Pediatric Neurology</option>
    <option value="Pediatric Pulmonology">Pediatric Pulmonology</option>
    <option value="Pediatric Surgery">Pediatric Surgery</option>
    <option value="Adolescent Health">Adolescent Health</option>
    <option value="Child Development">Child Development</option>
    <option value="Neonatal Intensive Care">Neonatal Intensive Care</option>
    <option value="Pediatric Critical Care">Pediatric Critical Care</option>
    <option value="Pediatric Emergency Medicine">Pediatric Emergency Medicine</option>
    <option value="Pediatric Infectious Diseases">Pediatric Infectious Diseases</option>
  </optgroup>

  {/* Mental Health and Psychiatric Specialties */}
  <optgroup label="Mental Health and Psychiatric Specialties">
    <option value="Addiction Nursing">Addiction Nursing</option>
    <option value="Child and Adolescent Psychiatry">Child and Adolescent Psychiatry</option>
    <option value="Geriatric Psychiatry">Geriatric Psychiatry</option>
    <option value="Psychiatric-Mental Health Nursing">Psychiatric-Mental Health Nursing</option>
    <option value="Adolescent Psychiatry">Adolescent Psychiatry</option>
    <option value="Adult Psychiatry">Adult Psychiatry</option>
    <option value="Child Psychiatry">Child Psychiatry</option>
    <option value="Clinical Psychology">Clinical Psychology</option>
    <option value="Cognitive-Behavioral Therapy">Cognitive-Behavioral Therapy</option>
    <option value="Forensic Psychiatry">Forensic Psychiatry</option>
    <option value="Geropsychiatry">Geropsychiatry</option>
    <option value="Neuropsychiatry">Neuropsychiatry</option>
  </optgroup>

  {/* Women's Health and Obstetric Specialties */}
  <optgroup label="Women's Health and Obstetric Specialties">
    <option value="Gynecology">Gynecology</option>
    <option value="Maternal-Child Health">Maternal-Child Health</option>
    <option value="Obstetrics">Obstetrics</option>
    <option value="Women's Health">Women's Health</option>
    <option value="Antepartum Nursing">Antepartum Nursing</option>
    <option value="Breastfeeding Support">Breastfeeding Support</option>
    <option value="Fertility Nursing">Fertility Nursing</option>
    <option value="Gynecologic Oncology">Gynecologic Oncology</option>
    <option value="Maternal-Fetal Medicine">Maternal-Fetal Medicine</option>
    <option value="Midwifery">Midwifery</option>
    <option value="Perinatal Nursing">Perinatal Nursing</option>
    <option value="Reproductive Endocrinology">Reproductive Endocrinology</option>
  </optgroup>

  {/* Other Specialties */}
  <optgroup label="Other Specialties">
    <option value="Critical Care">Critical Care</option>
    <option value="Emergency Nursing">Emergency Nursing</option>
    <option value="Occupational Health">Occupational Health</option>
    <option value="Palliative Care">Palliative Care</option>
    <option value="Rehabilitation Nursing">Rehabilitation Nursing</option>
    <option value="Transplant Nursing">Transplant Nursing</option>
    <option value="Wound, Ostomy, and Continence (WOC) Nursing">Wound, Ostomy, and Continence (WOC) Nursing</option>
    <option value="Aerospace Nursing">Aerospace Nursing</option>
    <option value="Alternative/Complementary Nursing">Alternative/Complementary Nursing</option>
    <option value="Biotherapy">Biotherapy</option>
    <option value="Cardiac Rehabilitation">Cardiac Rehabilitation</option>
    <option value="Case Management">Case Management</option>
    <option value="Clinical Research Nursing">Clinical Research Nursing</option>
    <option value="Correctional Nursing">Correctional Nursing</option>
    <option value="Disaster Nursing">Disaster Nursing</option>
  </optgroup>

  {/* Advanced Practice Registered Nurse (APRN) Specialties */}
  <optgroup label="Advanced Practice Registered Nurse (APRN) Specialties">
    <option value="Nurse Practitioner (NP)">Nurse Practitioner (NP)</option>
    <option value="Certified Nurse Midwife (CNM)">Certified Nurse Midwife (CNM)</option>
    <option value="Certified Registered Nurse Anesthetist (CRNA)">Certified Registered Nurse Anesthetist (CRNA)</option>
    <option value="Clinical Nurse Specialist (CNS)">Clinical Nurse Specialist (CNS)</option>
    <option value="Acute Care Nurse Practitioner">Acute Care Nurse Practitioner</option>
    <option value="Adult-Gerontology Primary Care Nurse Practitioner">Adult-Gerontology Primary Care Nurse Practitioner</option>
    <option value="Family Nurse Practitioner">Family Nurse Practitioner</option>
    <option value="Gerontological Nurse Practitioner">Gerontological Nurse Practitioner</option>
    <option value="Neonatal Nurse Practitioner">Neonatal Nurse Practitioner</option>
    <option value="Oncology Nurse Practitioner">Oncology Nurse Practitioner</option>
    <option value="Pediatric Nurse Practitioner">Pediatric Nurse Practitioner</option>
    <option value="Psychiatric-Mental Health Nurse Practitioner">Psychiatric-Mental Health Nurse Practitioner</option>
    <option value="Women's Health Nurse Practitioner">Women's Health Nurse Practitioner</option>
  </optgroup>

  {/* Additional Fields */}
  <option value="Other/Another Specialty">Other/Another Specialty</option>
  <option value="Other Support Staff">Other Support Staff</option>

</select>
  {department === "" && (
    <div className="text-red-500 text-sm mt-1">
      Please select a department before proceeding.
    </div>
  )}
</div>


            {/* State Input */}
            <div className="text-left">
              <label className="text-[15px] text-gray-700">Enter your State</label>
              <input
                type="text"
                required
                className="w-full px-3 py-1.5 border rounded-lg bg-bginput my-1 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all text-sm"
                placeholder="Enter State"
                value={state}
                onChange={(e) => setState(e.target.value)}
              />
            </div>

            <div className="text-left">
              <label className="text-[15px] text-gray-700">Enter your City</label>
              <input
                type="text"
                required
                className="w-full px-3 py-1.5 border rounded-lg bg-bginput my-1 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all text-sm"
                placeholder="Enter City"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
            </div>

            {/* Mobile Number Input */}
            <div className="text-left">
              <label className="text-[15px] text-gray-700">Enter your Mobile Number</label>
              <input
                type="text"
                required
                className="w-full px-3 py-1.5 border rounded-lg bg-bginput my-1 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all text-sm"
                placeholder="Enter Mobile Number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>

            {/* Doctor Name Input */}
            <div className="text-left">
              <label className="text-[15px] text-gray-700">Enter Under Dr. (Name)</label>
              <input
                type="text"
                required
                className="w-full px-3 py-1.5 border rounded-lg bg-bginput my-1 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all text-sm"
                placeholder="Enter Under Dr. Name"
                value={doctor}
                onChange={(e) => setDoctor(e.target.value)}
              />
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full bg-blue-500 hover:bg-blue-600 text-white px-4 py-1.5 rounded-lg font-medium transition-all text-sm"
            >
              {loader ? (
                <div className="animate-spin h-4 w-4 border-t-2 border-white border-solid mx-auto"></div>
              ) : (
                <span>Proceed</span>
              )}
            </button>

            {/* Response Message */}
            {responseMessage && (
              <div className="text-green-500 mt-2 text-sm">{responseMessage}</div>
            )}
          </form>

          {/* Login Link */}
          <div className="mt-3 text-[13px] text-gray-600">
            Already have an account?{" "}
            <Link to="/login" className="text-blue-500 hover:underline">
              Login Here
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupForm;
